import React from 'react';
import { Link } from 'react-router-dom';
import { BookIcon, TwitterIcon, InstagramIcon, FacebookIcon, InfoIcon } from 'lucide-react';
import { usePlatform } from '../../context/PlatformContext';
const Footer = () => {
  const {
    isAfterTide
  } = usePlatform();
  return <footer className={isAfterTide ? 'bg-[#1a1a2e] text-[#f5f0e8]' : 'bg-gray-900 text-white'} data-id="element-1960" data-mp="2d4a04axvywqp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1961" data-mp="292wspwf5alho">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1962" data-mp="24byauseidfcb">
          {/* Brand Column */}
          <div data-id="element-1963" data-mp="1zcv4n4msl32r">
            <Link to={isAfterTide ? '/aftertide' : '/'} className="flex items-center" data-id="element-1964" data-mp="1zclmg37zo07m">
              {isAfterTide ? <span className="font-playfair text-xl font-bold text-[#e2b04a]" data-id="element-1965" data-mp="1ubnwv5kng3w3">
                  AfterTide
                </span> : <>
                  <BookIcon className="h-8 w-8 text-purple-400" data-id="element-1966" data-mp="1ledkfgw3i8pl" />
                  <span className="ml-2 text-xl font-bold" data-id="element-1967" data-mp="29wykb9vteqph">LitLaunch</span>
                </>}
            </Link>
            <p className={`mt-4 text-sm ${isAfterTide ? 'text-[#a0a0b0]' : 'text-gray-300'}`} data-id="element-1968" data-mp="2eoypphunmbtg">
              {isAfterTide ? 'A controlled adult literary imprint. Curated dark fiction for discerning readers.' : 'A multi-vendor platform built for the self-publishing community, combining book discovery with merchandise sales.'}
            </p>
            <div className="mt-6 flex space-x-4" data-id="element-1969" data-mp="2xlq69jitactt">
              <a href="#" className={`${isAfterTide ? 'text-[#a0a0b0] hover:text-[#e2b04a]' : 'text-gray-400 hover:text-white'}`} data-id="element-1970" data-mp="2jn9ydp97qga3">
                <TwitterIcon className="h-5 w-5" data-id="element-1971" data-mp="2nqy5y7xuhbvc" />
              </a>
              <a href="#" className={`${isAfterTide ? 'text-[#a0a0b0] hover:text-[#e2b04a]' : 'text-gray-400 hover:text-white'}`} data-id="element-1972" data-mp="187bm7ciqne4n">
                <InstagramIcon className="h-5 w-5" data-id="element-1973" data-mp="3ewn1my53v0cy" />
              </a>
              <a href="#" className={`${isAfterTide ? 'text-[#a0a0b0] hover:text-[#e2b04a]' : 'text-gray-400 hover:text-white'}`} data-id="element-1974" data-mp="39xad88yl5l89">
                <FacebookIcon className="h-5 w-5" data-id="element-1975" data-mp="354h7pivam8v4" />
              </a>
            </div>
          </div>

          {/* For Readers Column */}
          <div data-id="element-1976" data-mp="2w6f2ss8fuw2k">
            <h3 className={`text-sm font-semibold uppercase tracking-wider ${isAfterTide ? 'text-[#f5f0e8]' : ''}`} data-id="element-1977" data-mp="2w6x5o7plw8jg">
              For Readers
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-1978" data-mp="2m6wk0f49lgc3">
              {isAfterTide ? <>
                  <li data-id="element-1979" data-mp="2h9ek1e886bg8">
                    <Link to="/aftertide/browse" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1980" data-mp="2h9wnautb1pxn">
                      Browse Catalog
                    </Link>
                  </li>
                  <li data-id="element-1981" data-mp="nyijo9yqymrt">
                    <Link to="/aftertide/library" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1982" data-mp="nz20togkp74s">
                      My Library
                    </Link>
                  </li>
                  <li data-id="element-1983" data-mp="wswzqer3q1bz">
                    <Link to="/aftertide/wishlist" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1984" data-mp="11pdv9u0mrhz3">
                      Wishlist
                    </Link>
                  </li>
                  <li data-id="element-1985" data-mp="919rje1mdez1">
                    <Link to="/aftertide/preferences" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1986" data-mp="92t4auo2h7w2">
                      Content Preferences
                    </Link>
                  </li>
                  <li data-id="element-1987" data-mp="1peq24n8hjdy8">
                    <Link to="/aftertide/book-clubs" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1988" data-mp="1phm2ei7t2epu">
                      Book Clubs
                    </Link>
                  </li>
                  <li data-id="element-1989" data-mp="2yd80jwqkisq7">
                    <Link to="/aftertide/recommendations" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-1990" data-mp="2ye0zwcn76fyb">
                      Recommendations
                    </Link>
                  </li>
                </> : <>
                  <li data-id="element-1991" data-mp="3hb28s8jvh07j">
                    <Link to="/create-reader-account" className="text-gray-300 hover:text-white text-sm font-medium" data-id="element-1992" data-mp="3hbkedvsfcqs4">
                      Create Reader Account
                    </Link>
                  </li>
                  <li data-id="element-1993" data-mp="8v8rvslmpmpy">
                    <Link to="/browse" className="text-gray-300 hover:text-white text-sm" data-id="element-1994" data-mp="8uphqy2802mh">
                      Browse Books
                    </Link>
                  </li>
                  <li data-id="element-1995" data-mp="nihbnht070dj">
                    <Link to="/browse?type=merch" className="text-gray-300 hover:text-white text-sm" data-id="element-1996" data-mp="ng3gl8ybpo5z">
                      Book Merchandise
                    </Link>
                  </li>
                  <li data-id="element-1997" data-mp="ihjrizofnw9e">
                    <Link to="/events" className="text-gray-300 hover:text-white text-sm" data-id="element-1998" data-mp="ih0adl6lxbwf">
                      Author Events
                    </Link>
                  </li>
                  <li data-id="element-1999" data-mp="3qywpv9k2jquc">
                    <Link to="/narrators" className="text-gray-300 hover:text-white text-sm" data-id="element-2000" data-mp="3qzpofn8vja1e">
                      Audiobook Narrators
                    </Link>
                  </li>
                </>}
            </ul>
          </div>

          {/* For Businesses Column */}
          <div data-id="element-2001" data-mp="3m1egxj61xbmc">
            <h3 className={`text-sm font-semibold uppercase tracking-wider ${isAfterTide ? 'text-[#f5f0e8]' : ''}`} data-id="element-2002" data-mp="1sgkwhawf5h0i">
              For Businesses
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-2003" data-mp="1ir1cg1wyzh42">
              {isAfterTide ? <>
                  <li data-id="element-2004" data-mp="1dryj3eqcqzbx">
                    <Link to="/aftertide/dashboard" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2005" data-mp="1dsq1fnuxv0k9">
                      Dashboard
                    </Link>
                  </li>
                  <li data-id="element-2006" data-mp="26eja2e2x19ey">
                    <Link to="/aftertide/catalog" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2007" data-mp="21h98k02957ar">
                      Manage Catalog
                    </Link>
                  </li>
                  <li data-id="element-2008" data-mp="q3oyuh8sejmw">
                    <Link to="/aftertide/analytics" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2009" data-mp="q0179nmwk7at">
                      Analytics
                    </Link>
                  </li>
                  <li data-id="element-2010" data-mp="31qiqc24gx17f">
                    <Link to="/aftertide/marketing" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2011" data-mp="31pzaqs2aiowk">
                      Marketing Tools
                    </Link>
                  </li>
                  <li data-id="element-2012" data-mp="3gdk9k9s4u1yo">
                    <Link to="/aftertide/arc" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2013" data-mp="3ge3rhqhs8qcp">
                      ARC Management
                    </Link>
                  </li>
                </> : <>
                  <li data-id="element-2014" data-mp="3udljsfuaelqt">
                    <Link to="/create-vendor-account" className="text-gray-300 hover:text-white text-sm font-medium flex items-center" data-id="element-2015" data-mp="1v1ahyy6rttuk">
                      Create Business Account
                      <span className="ml-1 group relative" data-id="element-2016" data-mp="5r73bmncq2jb">
                        <InfoIcon className="h-3.5 w-3.5 text-gray-400" data-id="element-2017" data-mp="1r6bn0b8ruub" />
                        <span className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-xs text-white py-1 px-2 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none transition-opacity" data-id="element-2018" data-mp="1p3pwsh4gnve">
                          Authors, Narrators, Vendors
                        </span>
                      </span>
                    </Link>
                  </li>
                  <li data-id="element-2019" data-mp="3ezswi1x4qcmx">
                    <Link to="/dashboard" className="text-gray-300 hover:text-white text-sm flex items-center" data-id="element-2020" data-mp="3sxr0cddtqqo6">
                      Dashboard
                      <span className="ml-1 group relative" data-id="element-2021" data-mp="1867apevkct54">
                        <span className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-xs text-white py-1 px-2 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none transition-opacity" data-id="element-2022" data-mp="188tk7k20lipz">
                          Authors, Narrators, Vendors
                        </span>
                      </span>
                    </Link>
                  </li>
                  <li data-id="element-2023" data-mp="2h3xfvk7ium9z">
                    <Link to="/sell" className="text-gray-300 hover:text-white text-sm flex items-center" data-id="element-2024" data-mp="2h3fbu1emb3ri">
                      Sell on LitLaunch
                      <span className="ml-1 group relative" data-id="element-2025" data-mp="38u1tn00s0b28"></span>
                    </Link>
                  </li>
                  <li data-id="element-2026" data-mp="2v2wzgdg6gaza">
                    <Link to="/resources" className="text-gray-300 hover:text-white text-sm flex items-center" data-id="element-2027" data-mp="2v1ly0ka7ffbc">
                      Resources
                      <span className="ml-1 group relative" data-id="element-2028" data-mp="3nqj3fmtbhhmo"></span>
                    </Link>
                  </li>
                  <li data-id="element-2029" data-mp="1ergoumdoghgw">
                    <Link to="/licensing" className="text-gray-300 hover:text-white text-sm flex items-center" data-id="element-2030" data-mp="1eqxje557rljr">
                      Licensing Guide
                      <span className="ml-1 group relative" data-id="element-2031" data-mp="15pqxfgjspij4"></span>
                    </Link>
                  </li>
                </>}
            </ul>
          </div>

          {/* Company Column */}
          <div data-id="element-2032" data-mp="vz4ryf5sm8e5">
            <h3 className={`text-sm font-semibold uppercase tracking-wider ${isAfterTide ? 'text-[#f5f0e8]' : ''}`} data-id="element-2033" data-mp="vymlyqtbwft1">
              Company
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-2034" data-mp="m44bn2tepm09">
              {isAfterTide ? <>
                  <li data-id="element-2035" data-mp="r25ze11s29i2">
                    <Link to="/aftertide/about" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2036" data-mp="qz9wrzeziwna">
                      About AfterTide
                    </Link>
                  </li>
                  <li data-id="element-2037" data-mp="3ulbrm5942vq8">
                    <Link to="/aftertide/content-guidelines" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2038" data-mp="3uksldlstpvs1">
                      Content Guidelines
                    </Link>
                  </li>
                  <li data-id="element-2039" data-mp="3dg2n2calaa0">
                    <Link to="/aftertide/privacy" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2040" data-mp="3cxyljje1rrj">
                      Privacy Policy
                    </Link>
                  </li>
                  <li data-id="element-2041" data-mp="r43etzt8qm2d">
                    <Link to="/aftertide/terms" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2042" data-mp="r3aephoseut7">
                      Terms of Service
                    </Link>
                  </li>
                  <li data-id="element-2043" data-mp="v5ou1rt8zcfq">
                    <Link to="/aftertide/contact" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm" data-id="element-2044" data-mp="v6ggac0yfxtc">
                      Contact Us
                    </Link>
                  </li>
                </> : <>
                  <li data-id="element-2045" data-mp="1rw0nga8yjuz">
                    <Link to="/about" className="text-gray-300 hover:text-white text-sm" data-id="element-2046" data-mp="1qktr7li8vzn">
                      About Us
                    </Link>
                  </li>
                  <li data-id="element-2047" data-mp="ghbpgqq7wf81">
                    <Link to="/donations" className="text-gray-300 hover:text-white text-sm" data-id="element-2048" data-mp="ggipc8lrknyv">
                      Donation Breakdown
                    </Link>
                  </li>
                  <li data-id="element-2049" data-mp="pfxbivuwecdk">
                    <Link to="/privacy" className="text-gray-300 hover:text-white text-sm" data-id="element-2050" data-mp="2n8b59ikjjr9q">
                      Privacy Policy
                    </Link>
                  </li>
                  <li data-id="element-2051" data-mp="2jropnvs9nnki">
                    <Link to="/terms" className="text-gray-300 hover:text-white text-sm" data-id="element-2052" data-mp="2js6rd7xp6tzt">
                      Terms of Service
                    </Link>
                  </li>
                  <li data-id="element-2053" data-mp="25zi9wat0zill">
                    <Link to="/contact" className="text-gray-300 hover:text-white text-sm" data-id="element-2054" data-mp="2600blmygip0w">
                      Contact Us
                    </Link>
                  </li>
                </>}
            </ul>
          </div>
        </div>

        {/* Cross-Platform Sister Site Link */}
        <div className={`mt-12 pt-8 border-t ${isAfterTide ? 'border-[#16213e]/50' : 'border-gray-800/50'} flex justify-center`} data-id="element-2055" data-mp="2opq76ca1netv">
          {isAfterTide ? <Link to="/" className="text-[#a0a0b0] hover:text-[#e2b04a] text-sm flex items-center transition-colors group" data-id="element-2056" data-mp="1da1jtjsvodsj">
              <span className="text-[#a0a0b0] group-hover:text-[#e2b04a] mr-2 transition-colors" data-id="element-2057" data-mp="315etm1nobjxt">
                ✦
              </span>
              Looking for all-ages fiction? Visit{' '}
              <span className="font-semibold ml-1" data-id="element-2058" data-mp="2s7mcqt2b048b">LitLaunch</span> — our main
              platform
            </Link> : <Link to="/aftertide" className="text-gray-500 hover:text-gray-300 text-sm flex items-center transition-colors group" data-id="element-2059" data-mp="2w5aeog2eyx9p">
              <span className="text-gray-400 group-hover:text-purple-400 mr-2 transition-colors" data-id="element-2060" data-mp="3oviwg6t1ffnr">
                ✦
              </span>
              Looking for mature fiction? Visit{' '}
              <span className="font-semibold ml-1" data-id="element-2061" data-mp="3fu2mu1a1rhkl">AfterTide</span> — our 18+
              imprint
            </Link>}
        </div>

        <div className={`mt-8 border-t ${isAfterTide ? 'border-[#16213e]' : 'border-gray-800'} pt-8 text-sm text-center ${isAfterTide ? 'text-[#a0a0b0]' : 'text-gray-400'}`} data-id="element-2062" data-mp="24ggygic0hk04">
          <p data-id="element-2063" data-mp="1rxv3s8sa8mal">
            &copy; {new Date().getFullYear()}{' '}
            {isAfterTide ? 'AfterTide' : 'LitLaunch'}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;